import { AbstractSingleton } from "./abstract.singleton";

class ClickSingleton extends AbstractSingleton {
    protected opened = false;
    public isOpened() {
        return this.opened;
    }
    public toogle() {
        this.opened = !this.opened;
    }
}

export const clickSingleton = new ClickSingleton();
